<style lang="scss">
  .z-myBusiness-footer{
    font-size:.8em;
  }
</style>
<template>
    <div class="z-myBusiness-footer" :style="{color: $root.colorToHex(textColor)}">{{$translate('Zoezi MyBusiness — Website and business system in one solution from')}} <a :style="{color: $root.colorToHex(linkColor)}" href="https://zoezi.se" target="_blank">Zoezi AB</a> - {{$translate('for increased growth and profitability!')}}</div>
</template>

<script>

export default {
    name: 'my-business-footer',
    zoezi: {
        title: 'MyBusiness footer',
        icon: 'mdi-page-layout-footer'
    },

    props: {
        textColor: {
            title: 'Text color',
            type: String,
            fulltype: 'color',
            default: '#333333'
        },
        linkColor: {
            title: 'Link color',
            type: String,
            fulltype: 'color',
            default: 'primary'
        }
    },

    methods: {
       
    }
}
</script>
